import React, { useState, useEffect, useMemo } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../utils/companyId";
import AddOffRoad from "./AddOffRoad";
import ViewOffRoad from "./ViewOffRoad";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import { getMonthName } from "../../../../utils/getMonthName";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import OffroadCard from "./OffroadCard";
import { truncateNumber } from "../../../../utils/common";
import BulkUpload from "../../StationaryCombustion.js/NaturalGas/BulkUpload";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import StationaryBulkUpload from "../../../../Components/Common/StatioaryBulkUpload";
const OffRoad = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Consumption Month": false,
    "Industrial Process": false,
    "Machinery Type Type": false,
    "Industrial Equipment": false,
    "Fuel Type": false,
    "Fuel Consumed": false,
    "Hours Used": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [filterValues, setFilterValue] = useState([]);
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    "Industrial Process": false,
    "Equipment Type": false,
    "Industrial Equipment": false,
    "Fule Type": false,
    "Fuel Consumed": false,
    "Hours Used": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    machineryType: [],
    fuelType: [],
    machineryCategory: [],
  });
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [hoursRange, setHoursRange] = useState({ min: "", max: "" });
  const [bulkUploadModal, setBulkUploadModal] = useState(false);

  const [excelData, setExcelData] = useState(null);
  const [fuelName, setFuelName] = useState("");
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [jsonBulkUpload, setJsonBulkUpload] = useState([]);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    machineryType: [],
    fuelType: [],
    machineryCategory: [],
    quantityRange: { min: "", max: "" },
    hoursRange: { min: "", max: "" },
    startMonth: null,
    endMonth: null,
  });
  const [categoryOptions, setCategoryOptions] = useState([]);

  const fetchExcelData = async () => {
    await get("/scope1/mobileCombustion/offroad/equipment")
      .then((res) => {
        let data = res?.data?.data;
        let data2 = res?.data?.uniqueIdObjects;
        
        // Create Cumulative Data Entry array (machinery names only)
        let arr = data && data?.map((el, idx) => {
          return {
            "Month (in 01/25 or Jan-25)": "",
            "Machinery Name": el?.name,
            "Fuel Consumed (in Litres)": "",
            "Hours Used (optional)": "",
            "Remark (optional)": "",
          };
        });

        // Create Individual Data Entry array (with unique IDs)
        let arr2 = data2 && data2?.map((el, idx) => {
          return {
            "Month (in 01/25 or Jan-25)": "",
            "Machinery Name": el?.name,
            "Unique ID of Machinery": el?.uniqueID,
            "Fuel Consumed (in Litres)": "",
            "Hours Used (optional)": "",
            "Remark (optional)": "",
          };
        });
        
        setExcelData([
          { name: "Cumulative Data Entry", data: arr },
          { name: "Individual Data Entry", data: arr2 }
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const filters = [
    "Date",
    "Consumption Month",
    "Machinery Category",
    "Machinery Type",
    "Fuel Type",
    "Fuel Consumed",
    "Hours Used",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },
    {
      fieldName: "machineryCategory",
      title: "Category of Machinery",
      placeholder: "Select equipment type",
      type: "select",
      options: ["Construction", "Industrial"],
      required: true,
    },
    {
      fieldName: "machineryType",
      title: "Machinery Type",
      placeholder: "Select equipment type",
      type: "machineType",
      url: `/master/getAllMachinery`,
      required: true,
    },
    {
      fieldName: "machineryName",
      title: "Machinery Name",
      placeholder: "Select equipment type",
      type: "machineryName",
      url: `${api}/master/getAllMachinery`,
    },
    {
      fieldName: "typeOfEntry",
      title: "Type of Entry",
      placeholder: "Type here",
      type: "select",
      options: ["Cumulative", "Individual"],
      required: true,
    },
    {
      fieldName: "uniqueIdOfEquipment",
      title: "Unique ID of Entry",
      placeholder: "Select industrial equipment",
      type: "uniqueIdOfEquipment",
      url: `${api}/master/getAllMachinery`,
      condition: true,
    },
    {
      fieldName: "fuelType",
      title: "Fuel Type",
      placeholder: "Auto filed",
      type: "text",
      required: true,
    },
    {
      fieldName: "fuelConsumed",
      title: "Fuel Consumed",
      placeholder: "Enter Fuel Consumed ",
      type: "number",
      condition: true,
      adornmentText: "",
    },
    {
      fieldName: "usedhours",
      title: "Hours Used (optional)",
      placeholder: "Enter hours",
      // type: "number",
      condition: true,
    },
    // {
    //   fieldName: "unit",
    //   title: "Unit of Quantity",
    //   placeholder: "Select unit",
    //   type: "select",
    //   options: [
    //     "NG-m3",
    //     "Coal-MT",
    //     "Petrol-litres",
    //     "Diesel-litres",
    //     "Fuel Oil-litres",
    //   ],
    //   required: true,
    // },
    // {
    //   fieldName: "calorificValue",
    //   title: "Calorific Value",
    //   placeholder: "10000",
    //   type: "number",
    //   required: true,
    // },
    // {
    //   fieldName: "calorificValue.unit",
    // //   title: "Calorific Value Unit",
    //   placeholder: "Select unit",
    //   type: "select",
    //   options: ["MJ/kg", "MJ/m3"],
    //   required: true,
    // },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  useEffect(() => {
    get(`/master/getAllMachineryType`)
      .then((res) => {
        if (res.data && Array.isArray(res.data.data)) {
          setCategoryOptions(
            res.data.data.map((item) => ({
              id: item._id,
              name: item.type,
            }))
          );
        } else {
          console.log("Unexpected response structure:", res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const uniqueMachineCategories = useMemo(() => {
    const seen = new Set();
    return categoryOptions.filter((category) => {
      const duplicate = seen.has(category.name);
      seen.add(category.name);
      return !duplicate;
    });
  }, [categoryOptions]);

  const bulkuploadInputData = [
    {
      fieldName: "location",
      title: "Location",
      placeholder: "Enter Name",
      type: "text",
    },
    {
      fieldName: "machineCategory",
      title: "Machinery Category",
      placeholder: "Tap to Select",
      type: "select",
      // options: ["Industrial", "Construction"],
      // selectUrl: `/master/getAllMachineryType`,
      // field: "type",
      options: uniqueMachineCategories,
      required: true,
    },
    {
      fieldName: "machineType",
      title: "Equipment Type",
      placeholder: "Tap to Select",
      type: "select",
      // selectUrl: `/master/getAllMachineryType`,
      selectUrl: `/master/getAllMachineryType`,
      field: "name",
      required: true,
    },
    {
      fieldName: "name",
      title: "Machinery Name",
      placeholder: "Enter Name",
      type: "text",
      required: true,
      disabled: true,
    },
    {
      fieldName: "fuelType",
      title: "Fuel Type",
      placeholder: "Enter Fuel Type",
      type: "select",
      options: [
        "Diesel (100% mineral diesel)",
        "Petrol (100% mineral petrol)",
        "Electricity",
      ],
      required: true,
    },
    {
      fieldName: "numberOfMachines",
      title: "No of Machinery",
      placeholder: "Enter No of Machinery",
      type: "number",
      required: true,
    },
  ];

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const fetchUniqueValues = async () => {
    try {
      const response = await get(
        `/scope1/mobileCombustion/getAllOFRoadVehicles`
      );
      const data = response.data.data;

      const uniqueIndustrialProcess = [
        ...new Set(data.map((el) => el.machineryCategory).filter(Boolean)),
      ];

      const uniqueEquipmentType = [
        ...new Set(
          data.map((el) => el.machineryType?.name).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueFuelType = [
        ...new Set(
          data.map((el) => el.fuelType).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniquequantityOfFuelConsumed = [
        ...new Set(
          data.map((el) => el.quantityOfFuelConsumed).filter(Boolean) // Filter out undefined values
        ),
      ];
      setFilterValue(uniqueFuelType);
      return {
        machineryCategory: uniqueIndustrialProcess,
        machineryType: uniqueEquipmentType,
        fuelType: uniqueFuelType,
        quantityOfFuelConsumed: uniquequantityOfFuelConsumed,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope1/mobileCombustion/getAllOFRoadVehicles?${queryParams}`
      );

      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
      setFuelName(uniqueValues?.fuelType[0]);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  const fetchCardData = async () => {
    try {
      const response = await get(
        `/scope1/mobileCombustion/getAllOFRoadVehicles`
      );
      const data = response.data.data;
      const uniqueFuelType = [
        ...new Set(data.map((el) => el.fuelType).filter(Boolean)),
      ];
      setFilterValue(uniqueFuelType);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM")
      : "",
    fuelType: tempFilter?.fuelType || "",
    machineryCategory: tempFilter?.machineryCategory || "",
    machineryType: tempFilter?.machineryType || "",
    minQuantity: tempFilter?.quantityRange.min || "",
    maxQuantity: tempFilter?.quantityRange.max || "",
    minHours: tempFilter?.hoursRange.min || "",
    maxHours: tempFilter?.hoursRange.max || "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Machinery Category": false,
      "Machinery Type": false,
      "Fuel Type": false,
      "Fuel Consumed": false,
      "Hours Used": false,
    };

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date
      // if (!startDate && !endDate) {
      //   newErrors.Date = "Please select start date & end date";
      //   isValid = false;
      // }

      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    if (selectedFilter === "Fuel Consumed") {
      const min = parseFloat(tempFilter?.quantityRange.min);
      const max = parseFloat(tempFilter?.quantityRange.max);

      if (!min && !max) {
        newErrors["Fuel Consumed"] = "Please provide both min and max values";
        isValid = false;
      }

      if (min && isNaN(min)) {
        newErrors["Fuel Consumed"] = "Min consumption must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Fuel Consumed"] = "Max consumption must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Fuel Consumed"] =
          "Min consumption cannot be greater than max consumption";
        isValid = false;
      }
    }

    if (selectedFilter === "Hours Used") {
      const min = parseFloat(tempFilter?.hoursRange.min);
      const max = parseFloat(tempFilter?.hoursRange.max);

      if (!min && !max) {
        newErrors["Hours Used"] = "Please provide both min and max values";
        isValid = false;
      }

      if (min && isNaN(min)) {
        newErrors["Hours Used"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Hours Used"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Hours Used"] =
          "Min hours cannot be greater than max consumption";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      fuelType: tempFilter?.fuelType || [],
      machineryType: tempFilter?.machineryType || [],
      machineryCategory: tempFilter?.machineryCategory || [],
    });
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    setQuantityRange(tempFilter?.quantityRange || { min: "", max: "" });
    setHoursRange(tempFilter?.hoursRange || { min: "", max: "" });
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  console.log("first23", tempFilter);

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      equipmentType: [],
      machineryCategory: [],
      machineryType: [],
      quantityRange: { min: "", max: "" },
      hoursRange: { min: "", max: "" },
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      fuelType: [],
      machineryType: [],
      machineryCategory: [],
    });
    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isMachineCategoryApplied = tempFilter?.machineryCategory?.length > 0;
    const isEquipmentTypeApplied = tempFilter?.machineryType?.length > 0;
    const isMachineryCategory = tempFilter?.machineryCategory?.length > 0;
    const isfuelTypeApplied = tempFilter?.fuelType?.length > 0;
    const isQuantityRangeApplied =
      tempFilter?.quantityRange?.min && tempFilter?.quantityRange?.max;
    const isHoursRangeApplied =
      tempFilter?.hoursRange.min && tempFilter?.hoursRange.max;
    setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isMachineCategoryApplied ||
        isEquipmentTypeApplied ||
        isQuantityRangeApplied ||
        isHoursRangeApplied ||
        isMachineryCategory ||
        isfuelTypeApplied
    );
    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isMonthApplied,
      "Machinery Category": isMachineryCategory,
      "Machinery Type": isEquipmentTypeApplied,
      "Industrial Equipment": isMachineCategoryApplied,
      "Fuel Type": isfuelTypeApplied,
      "Fuel Consumed": isQuantityRangeApplied,
      "Hours Used": isHoursRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      machineryType: selectedFields.machineryType,
      machineryCategory: selectedFields.machineryCategory,
      fuelType: selectedFields.fuelType,
      quantityRange: quantityRange,
      hoursRange: hoursRange,
    });
    setDrawerFilterOpen(false);
    // setErrors({ Date: false, Role: false });
  };

  const columnHeadings = [
    { title: "Date", fieldName: "createdAt" },
    { title: "Consumption Month", fieldName: "consumptionPeriod" },
    { fieldName: "machineryType", title: "Machinery Type" },
    { fieldName: "machineryName", title: "Name of Machinery" },
    { fieldName: "fuelType", title: "Fuel Type" },
    { fieldName: "fuelConsumed", title: "Fuel Consumed" },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
          />
        );
      case "Machinery Type":
        return (
          <MultiSelect
            title="Machinery Type"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  machineryType: newValue.machineryType || newValue,
                };
              });
            }}
            errors={errors["Machinery Type"]}
            setErrors={setErrors}
            field="machineryType"
            data={uniqueValues.machineryType}
          />
        );
      case "Name of Machinery":
        return (
          <MultiSelect
            title="Name of Machinery"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  machineryName: newValue.machineryName || newValue,
                };
              });
            }}
            errors={errors["Name of Machinery"]}
            setErrors={setErrors}
            field="machineryName"
            data={uniqueValues.equipmentType}
          />
        );
      case "Machinery Category":
        return (
          <MultiSelect
            title="Machinery Category"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  machineryCategory: newValue.machineryCategory || newValue,
                };
              });
            }}
            errors={errors["Machine Category"]}
            setErrors={setErrors}
            field="machineryCategory"
            data={uniqueValues.machineryCategory}
          />
        );
      case "Fuel Type":
        return (
          <MultiSelect
            title="Fuel Type"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  fuelType: newValue.fuelType || newValue,
                };
              });
            }}
            errors={errors["Fuel Type"]}
            setErrors={setErrors}
            field="fuelType"
            data={uniqueValues.fuelType}
          />
        );
      case "Fuel Consumed":
        return (
          <Range
            title="Fuel Consumed"
            selectedRange={tempFilter?.quantityRange}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                quantityRange: data,
              }));
            }}
            errors={errors["Fuel Consumed"]}
            setErrors={setErrors}
            placeholderMin={"Min(litre)"}
            placeholderMax={"Max(litre)"}
          />
        );
      case "Hours Used":
        return (
          <Range
            title="Hours Used"
            selectedRange={tempFilter?.hoursRange}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                hoursRange: data,
              }));
            }}
            errors={errors["Hours Used"]}
            setErrors={setErrors}
            placeholderMin={"Min(hours)"}
            placeholderMax={"Max(hours)"}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <MessagePopup {...{ snackOpen, setsnackOpen }} />
      {/*Message popup for success or failure */}
      {/* View log, Edit, delete menus */}
      <AddOffRoad
        id={element ? element._id : ""}
        addData={addData}
        setAddData={setAddData}
        data={element}
        addUrl={`${api}/scope1/mobileCombustion/addOFRoadVehicles`}
        updateUrl={`${api}/scope1/mobileCombustion/updateOFRoadVehicles`}
        // details={vehicle}
        fetchData={fetchData}
        setsnackOpen={setsnackOpen}
        inputData={inputData}
      />
      <ViewOffRoad
        id={element ? element._id : ""}
        data={element}
        viewData={viewData}
        setViewData={setViewData}
        inputData={inputData}
        handleEdit={handleEdit}
      />

      <OffroadCard list={filterValues} />

      {deleteDialog && (
        <DeleteAlertDialog
          // {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
          {...{
            deleteDialog,
            setDeleteDialog,
            id: element._id,
            url: `${api}/scope1/mobileCombustion/deleteOFRoadVehicles`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}
      {/* Filter Drawer */}
      {drawerFilterOpen && (
        <FilterDrawer
          {...{
            renderSelectedFilter,
            drawerFilterOpen,
            setDrawerFilterOpen,
            handleApplyFilters,
            handleFilterDrawer,
            setSelectedFilter,
            handleResetFilters,
            selectedFilter,
            filters,
            appliedFilters,
            selectedFields,
            setSelectedFields,
          }}
        />
      )}
      {/* Top Box for Heading, Filter Button, Add Data Button */}
      <TopMenuUpload
        setData={setElement}
        setAddData={setAddData}
        {...{
          // heading: "Coal",
          setBulkUploadModal,
          setDrawerFilterOpen,
          filterApplied: isFiltersApplied,
        }}
      />
      <TableContainer
        component={Paper}
        sx={{
          maxWidth: "100%",
          marginBottom: "1rem",
          //  margin: "3% 5% 0% 23%"
        }}
      >
        <Box>
          <TableHeading heading={"Off Road Vehicles and Equipments"} />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "12% 15% 15% 15% 20% 12% 8%",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {columnHeadings.map((el) => (
              <ColumnHeadings
                key={el}
                {...{
                  title: el.title,
                  key: el.title,
                  handleSort,
                  field: el.fieldName,
                  sortConfig,
                }}
              />
            ))}
            <Typography
              sx={{
                fontWeight: "bold",
                padding: "8px 12px",
                textAlign: "center",
              }}
            >
              Action
            </Typography>
          </Box>
          {data.length === 0 ? (
            <NoDataFound />
          ) : (
            data.map((item) => (
              <Box
                key={item._id}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 15% 15% 15% 20% 12% 8%",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <TableContent
                    key={el.fieldName}
                    {...{
                      fieldData:
                        el.fieldName === "consumptionPeriod"
                          ? getMonthName(item[el.fieldName]?.month) +
                            " " +
                            item[el.fieldName]?.year
                          : el.fieldName === "fuelConsumed"
                          ? truncateNumber(item[el.fieldName].value) +
                            " " +
                            item[el.fieldName].unit
                          : typeof [el.fieldName] === "object" &&
                            // [el.fieldName] !== null &&
                            [el.fieldName].name
                          ? [el.fieldName].name
                          : typeof item[el.fieldName] === "object" &&
                            item[el.fieldName] !== null &&
                            item[el.fieldName].value
                          ? item[el.fieldName].value
                          : item[el.fieldName],
                      dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                      //     fieldData:
                      //     typeof item[el.fieldName] === "object" && item[el.fieldName] !== null
                      //       ? item[el.fieldName] === "machineryType"
                      //         ? item[el.fieldName].type // Return `type` if `name` is "machineryType"
                      //         : item[el.fieldName].value ?? item[el.fieldName] // Return `value` if available, otherwise the object itself
                      //       : item[el.fieldName], // Fallback for non-object fields
                      //   dateField: el.fieldName === "createdAt",
                    }}
                  />

                  // console.log(el.fieldName,item,typeof item[el.fieldName],item[el.fieldName],"el.fieldName")
                ))}
                {/* Menu Action Icon */}

                <MenuIcon {...{ handleMenuClick, field: item }} />
              </Box>
            ))
          )}
        </Box>
      </TableContainer>
      {/* Pagination */}
      {totalPages > 1 && (
        <PaginationBox
          {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
        />
      )}
      <MenuActions
        {...{
          id: element?._id,
          handleView,
          handleEdit,
          handleDelete,
          anchorEl,
          handleMenuClose,
        }}
      />
      {/* {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          setsnackOpen={setsnackOpen}
          excelData={excelData}
          fileName={"off road"}
          url={"/scope1/mobileCombustion/offroad/bulkupload"}
        />
      )} */}
      {bulkUploadModal && (
        <StationaryBulkUpload
          onCloseBulkUpload={handleCloseBulkUpload}
          isBulkUploadModal={bulkUploadModal}
          setsnackOpen={setsnackOpen}
          setFormDataBulkUpload={setFormDataBulkUpload}
          excelData={excelData}
          setMatchData={setMatchData}
          errorClose={uploadErrorClose}
          setBulkUploadTable={setBulkUploadTable}
          setBulkUploadModal={setBulkUploadModal}
          formDataBulkUpload={formDataBulkUpload}
          fileName={"Off Road Vehicles"}
          title="Machinery Name"
          url={"/scope1/mobileCombustion/offroad/bulkupload"}
          setJsonBulkUpload={setJsonBulkUpload}
        />
      )}
      {bulkUploadTable && (
        <BulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          url={`/master/getAllMachinery`}
          // onAddItem={handleAddItem}
          // fuelType="Natural Gas"
          formData={formDataBulkUpload}
          submitUrl={`/master/addMachinery`}
          setFormData={setFormDataBulkUpload}
          bulkuploadInputData={bulkuploadInputData}
          title="Machinery Name"
          onConfirm={() => {
            // Handle the bulk upload confirmation here
            setBulkUploadTable(true);
            fetchData();
            // setsnackOpen({
            //   open: true,
            //   message: "Bulk upload completed successfully!",
            //   severity: "success",
            // });
          }}
          jsonBulkUpload={jsonBulkUpload}
          bulkUploadUrl={`/scope1/mobileCombustion/offroad/jsonupload`}
          setsnackOpen={setsnackOpen}
        />
      )}
      {/*Add,Edit,Delete Icons & function calls */}
    </Box>
  );
};

export default OffRoad;
